<template>
  <ValidationProvider :name="$attrs.label" :rules="rules">
    <v-combobox
      v-model="inputValue"
      slot-scope="{ errors }"
      :error-messages="errors"
      :items="items"
      :success="!errors.length && success"
      :disabled="$attrs.disabled"
      no-filter
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot:item="{ item }">
        <div class="item-container">
          <div class="item-primary">
            <span>{{ `${item.NazivDolgi} | ${item.Davcna}` }}</span>
          </div>
          <div class="item-secondary">
            <span>{{ getItemSecondaryText(item) }}</span>
          </div>
        </div>
      </template>
    </v-combobox>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'CompanyInput',
  components: {
    ValidationProvider,
  },
  props: {
    value: { type: [String, Object], default: null },
    items: { type: Array, default: () => [] },
    rules: {
      type: [Object, String],
      default: '',
    },
    success: { type: Boolean, default: false },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('update', value);
      },
    },
  },
  methods: {
    getItemSecondaryText(item) {
      if (!item.country) {
        return '';
      }
      return `${item.country} | ${item.external_api || 'Integracija ni znana'}`;
    },
  },
};
</script>
<style scoped>
.item-container {
  display: flex;
  flex-direction: column;
  padding: 5px;
  transition: color 0.3s ease, transform 0.3s ease;
  color: #484848;
}

.item-container:hover {
  color: black;
  transform: translateX(1%);
}

.item-primary {
  font-weight: bold;
  margin-bottom: 4px;
}

.item-secondary {
  font-size: 0.9rem;
}

.item-secondary span {
  display: block;
}
</style>
